export class MailRuTracker
{
    constructor() {
        this.init();
    }

    init() {
        window._tmr = window._tmr || [];
        return window._tmr;
    }

    push(query) {
        window._tmr.push(query);
    }

    indexPageView() {
        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'home'
        }));
    }

    otherPageView() {
        this.push(this.getQueryTemplate());
    }

    categoryPageView(products) {
        /*let ids = [], prices = [];
        products.forEach(product => {
            ids.push(product.id);
            prices.push(product.price);
        });*/
        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'category',
            productid: '', //ids.join(','),
            totalvalue: '' //prices.join(','),
        }));
    }

    basketPageView(basket) {
        let ids = [], totalPrice = 0.0;
        basket.forEach(product => {
            ids.push(product.id);
            totalPrice += parseFloat(product.price);
        });

        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'cart',
            productid: ids.join,
            totalvalue: totalPrice,
        }));
    }

    productPageView(product) {
        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'product',
            productid: product.id,
            totalvalue: parseFloat(product.price),
        }));
    }

    orderPageView() {
        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'purchase'
        }));
    }

    orderThankyouPageView(basket) {
        let ids = [], totalPrice = [];
        basket.forEach(product => {
            ids.push(product.id);
            totalPrice += parseFloat(product.price);
        });
        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'purchase',
            productid: ids,
            totalvalue: totalPrice,
        }));
    }

    searchPageView() {
        this.push(Object.assign(this.getQueryTemplate(), {
            pagetype: 'searchresults'
        }));
    }

    getQueryTemplate() {
        return {
            type: 'itemView',
            productid: '',
            pagetype: 'other',
            totalvalue: '',
            list: '3'
        }
    }
}


// WEBPACK FOOTER //
// ./modules/tracker/mailru.js